const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
const phoneRegex = /^(?=(?:\D*\d){9,11}\D*$)(\+?\d{1,2}[ -]?)?(\(\+?\d{2,3}\)|\+?\d{2,3})?[ -]?\d{2,4}[ -]?\d{2,4}[ -]?\d{2,3}$/;
const genderRegex = /^(male|female)$/;
const dobRegex = /^([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/ ;

const normalizePhoneForComparison = (phone) => {
  const digits = (phone || '').replace(/\D/g, '');

  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
};

export const csvFieldsValidate = (
  fileData = [],
  validateFields = [],
  isCustomer3 = false,
  quoteProStoreId = null,
  customerGroups = [],
  existingCustomersByEmail = new Map()
) => {
  if (!fileData.length || !validateFields.length) {
    return [];
  }

  const validationArrayOfObjects = fileData.map((fields) => {
    const obj = fields.reduce((acc, field, i) => ({...acc, [validateFields[i]]: field}), {});
    return obj;
  });

  const phoneOccurrences = validationArrayOfObjects.reduce((acc, customer) => {
    const normalizedPhone = normalizePhoneForComparison(customer['Phone For Login']);

    if (normalizedPhone) {
      acc[normalizedPhone] = (acc[normalizedPhone] || 0) + 1;
    }

    return acc;
  }, {});

  const emailOccurrences = validationArrayOfObjects.reduce((acc, customer) => {
    const normalizedEmail = (customer['Email'] || '').trim().toLowerCase();

    if (normalizedEmail) {
      acc[normalizedEmail] = (acc[normalizedEmail] || 0) + 1;
    }

    return acc;
  }, {});

  const validationResults = validationArrayOfObjects.reduce((acc, customer, index) => {
    const firstNameError = (customer['First Name']).trim().length === 0;
    const lastNameError = (customer['Last Name']).trim().length === 0;
    const practiceNameError = isCustomer3 && (customer['Company/Practice Name'] || '').trim().length === 0;
    const emailError = !emailRegex.test((customer['Email']).trim());
    const emailRequiredError = (customer['Email']).trim().length === 0;
    const normalizedEmail = (customer['Email'] || '').trim().toLowerCase();
    const emailDuplicateError = !!normalizedEmail && emailOccurrences[normalizedEmail] > 1;
    const phoneError = (!quoteProStoreId && (customer['Phone For Login']).trim().length === 0)
      ? ''
      : !phoneRegex.test((customer['Phone For Login']).trim());
    const normalizedPhone = normalizePhoneForComparison(customer['Phone For Login']);
    const phoneDuplicateError = !!normalizedPhone && phoneOccurrences[normalizedPhone] > 1;

    const genderMatchError = (customer['Gender']).trim().length === 0
      ? ''
      : !genderRegex.test((customer['Gender']).trim().toLowerCase());

    const dobError = (customer['Date Of Birth']).trim().length === 0
      ? ''
      : !dobRegex.test((customer['Date Of Birth']).trim());

    const groupValue = (customer['Group'] || '').trim();
    const groupMissingError = groupValue.length === 0;
    const groupInvalidError = !groupMissingError && customerGroups.length
      ? !customerGroups.some((g) => g.code.toLowerCase() === groupValue.toLowerCase())
      : false;

    const existingCustomer = existingCustomersByEmail.get((customer['Email']).trim().toLowerCase());
    const fileFullName = `${(customer['First Name']).trim()} ${(customer['Last Name']).trim()}`
      .replace(/\s+/g, ' ').trim().toLowerCase();
    const existingFullName = (existingCustomer?.name || '').replace(/\s+/g, ' ').trim().toLowerCase();
    const nameMismatchError = !!existingCustomer && fileFullName !== existingFullName;

    if (firstNameError) {
      acc = {...acc, [index]: {...acc[index], firstNameError: 'First Name is Required'}};
    }

    if (practiceNameError) {
      acc = {...acc, [index]: {...acc[index], practiceNameError: 'Company/Practice Name is Required'}};
    }

    if (emailError) {
      acc = {...acc, [index]: {...acc[index], emailError: 'Email is invalid'}};
    }

    if (emailRequiredError) {
      acc = {...acc, [index]: {...acc[index], emailError: 'Email is Required'}};
    }

    if (emailDuplicateError) {
      acc = {...acc, [index]: {...acc[index], emailDuplicateError: 'Email is duplicated in the file'}};
    }

    if (lastNameError) {
      acc = {...acc, [index]: {...acc[index], lastNameError: 'Last Name is Required'}};
    }

    if (phoneError) {
      acc = {...acc, [index]: {...acc[index], phoneError: 'Phone Number is invalid'}};
    }

    if (phoneDuplicateError) {
      acc = {...acc, [index]: {...acc[index], phoneDuplicateError: 'Phone Number is duplicated in the file'}};
    }

    if (genderMatchError) {
      acc = {
        ...acc,
        [index]: {
          ...acc[index],
          genderError: 'Gender is invalid, it should match to \'male\', \'female\' or leave empty if unknown'
        }
      };
    }

    if (dobError) {
      acc = {
        ...acc,
        [index]: {
          ...acc[index],
          dobError: 'Date Of Birth is invalid, it should match to mm/dd/yyyy format or leave empty if unknown'
        }
      };
    }

    if (groupMissingError) {
      acc = {...acc, [index]: {...acc[index], groupError: 'Group is Required'}};
    }

    if (groupInvalidError) {
      acc = {...acc, [index]: {...acc[index], groupError: 'Group is invalid, it should match one of the available store groups'}};
    }

    if (nameMismatchError) {
      acc = {
        ...acc,
        [index]: {
          ...acc[index],
          nameError: `First Name/Last Name does not match the existing customer in Magento ("${existingCustomer.name}")`
        }
      };
    }

    return acc;
  }, {});

  return validationResults;
};

